module.exports = "<div class=\"icon text-center padd\">\r\n    <div class=\"top_ico_bg darkshadow\">\r\n        <div *ngIf=\"currentStage\" class=\"{{currentStage.icon}}\" [@bounceIn]></div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/icon-status/icon-status.component.html
// module id = ./src/app/shared/components/icon-status/icon-status.component.html
// module chunks = main